<template>
  <div>
    <new-hobbie-popup
      :data-to-show="isNewHobbiePopupDisplayed"
      @close="changeStateNewHobbiePopup(false)"
      @addHobbie="
        (newValue) => {
          addNewHobbie(newValue);
        }
      "
      @modifyHobbie="
        (newValue) => {
          modifyHobbie(newValue);
        }
      "
      :hobbie-to-edit="hobbies[indexHobbieToEdit]"
    />

    <change-picture-popup
      :hobbie-to-edit="hobbies[indexHobbieToEdit]"
      :data-to-show="isChoosePicPopupDisplayed"
      @close="changeStateChoosePicPopup(false)"
      @changePic="
        (newValue) => {
          changePic(newValue);
        }
      "
      @removePic="removePic(indexHobbieToEdit)"
    />

    <change-icon-popup
      :hobbie-to-edit="hobbies[indexHobbieToEdit]"
      :data-to-show="isChooseIconPopupDisplayed"
      @close="changeStateChooseIconPopup(false)"
      @changeIcon="
        (newValue) => {
          changeIcon(newValue);
        }
      "
      @removeIcon="removeIcon(indexHobbieToEdit)"
    />

    <h3 class="my-15 mx-10">Centres d'intérêt</h3>

    <div
      v-if="isErrorMaxLengthDisplayed"
      class="text-pink-600 text-base text-center mb-8 mx-10"
    >
      Vous ne pouvez pas sélectionner plus de 3 centres d'intérêt.
    </div>
    <div
      v-if="isErrorMinLengthDisplayed"
      class="text-pink-600 text-base text-center mb-8 mx-10"
    >
      Afin d'avoir un rendu visuel optimal, il faut sélectionner exactement 3
      centres d'intérêt.
    </div>

    <div v-if="hobbies.length === 0">
      <h6 class="mx-15 text-gray-600">
        Aucun centre d'intérêt n'a été renseigné sur votre Neopass.
      </h6>
      <h6 class="mx-15 text-gray-600 mt-5">
        Pour mettre en avant vos centres d'intérêt, cliquer sur le bouton
        "ajouter des centres d'intérêt"
      </h6>

      <div class="flex justify-center mt-15">
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-600"
          icon-color="text-white"
          libelle="Ajouter des centres d'intérêt"
          :uppercase="true"
          icon="plus-circle"
          type-shadow="indigo-shadow"
          @clickAction="changeStateNewHobbiePopup(true)"
        />
      </div>

      <div class="flex justify-center mt-10">
        <illustration name="evaluation" />
      </div>
    </div>

    <div v-if="hobbies.length > 0 || newHobbies.length > 0">
      <draggable
        v-if="!isWithPictures && hobbies.length > 0"
        v-model="form.data.hobbies"
        v-bind="dragOptions"
        @end="drag = false"
        @start="drag = true"
      >
        <transition-group
          enter-active-class="ease-in duration-1000"
          enter-class="bg-indigo-300 border-0 rounded-xl"
          enter-to-class="bg-none border-0 rounded-xl"
          leave-active-class="linear duration-1000"
          leave-class="h-20 opacity-100"
          leave-to-class="h-0 opacity-0"
          tag="div"
          class="grid grid-cols-3 gap-3 mx-10"
        >
          <div
            v-for="(hobbie, kh) in hobbies"
            :key="'hobbie' + kh"
            class="col-span-full md:col-span-1 flex justify-center md:justify-start"
          >
            <tag
              @push="displayHobbie(kh)"
              class="cursor-pointer"
              :theme-color="hobbie.isDisplayed ? 'indigo-2' : 'white'"
              :libelle="hobbie.value"
              text-size="text-sm"
              text-font="font-light"
              :icon="hobbie.isDisplayed ? 'minus-circle' : 'plus-circle'"
              :icon-color="
                hobbie.isDisplayed ? 'text-indigo-600' : 'text-gray-600'
              "
              icon-size="w-4 h-4"
              :can-truncate="true"
              :scale-on-hover="true"
            />
          </div>
        </transition-group>
      </draggable>

      <div
        v-if="newHobbies && !isWithPictures"
        class="grid grid-cols-3 gap-3 mt-5 mx-10"
      >
        <div
          v-for="(hobbie, kh) in newHobbies"
          :key="'newhobbie' + kh"
          class="col-span-full md:col-span-1 flex md:space-x-1 items-center justify-center md:justify-start"
        >
          <CVNewValue
            :old="hobbie"
            @addNew="
              (newValue) => {
                importFromNeopass(hobbie);
              }
            "
            :right="false"
            :is-new="true"
          />
          <tag
            class="cursor-pointer"
            :theme-color="'white'"
            :libelle="hobbie.value"
            text-size="text-sm"
            text-font="font-light"
            :icon="'plus-circle'"
            :icon-color="'text-gray-600'"
            icon-size="w-4 h-4"
            :can-truncate="true"
            :scale-on-hover="true"
          />
        </div>
      </div>

      <div v-if="isWithPictures">
        <div
          v-for="(hobbie, kh) in hobbies"
          :key="'hobbie' + kh"
          class="col-span-full grid grid-cols-12 gap-x-4 py-5 odd:bg-gray-200 items-center odd:bg-opacity-50"
        >
          <div
            class="pl-5 md:pl-0 md:col-start-2 lg:col-start-3 col-span-8 md:col-span-7 flex space-x-1 items-center justify-between"
          >
            <div class="flex space-x-4 items-center">
              <icon :name="hobbie.icon" />
              <p class="text-base font-normal">
                {{ hobbie.value }}
              </p>
            </div>
            <img
              v-if="hobbie.image && hobbie.image != ''"
              :src="hobbie.image"
              class="h-8 w-8 object-cover rounded-md"
            />
          </div>

          <div class="col-span-4 lg:col-span-3 flex space-x-3 px-6 justify-end">
            <radio-button
              :name="'hobbie' + kh + '_display'"
              :value="
                ((((form || {}).data || {}).hobbies || [])[kh] || {})
                  .isDisplayed || false
              "
              @input="
                (newValue) => {
                  displayHobbie(kh);
                }
              "
              @loseFocus="saveDatas()"
            />
            <div
              v-if="!hobbie.fromNeopass || isWithPictures"
              class="cursor-pointer px-2 relative"
              @click.stop="displayMenuMore(kh)"
            >
              <icon name="more-vertical" class="text-pink-600" />
              <div
                v-if="menuMoreDisplayed === kh"
                v-click-outside="hideMenuMore"
                class="absolute text-gray-600 bg-white px-5 py-4 rounded-xl shadow-lg flex flex-col space-y-2 text-sm -right-full z-10 w-max"
              >
                <p
                  v-if="!hobbie.fromNeopass"
                  @click.stop="displayModifyHobbiePopup(kh)"
                  class="hover:text-gray-900 cursor-pointer"
                >
                  Modifier
                </p>
                <p
                  @click.stop="displayChoosePicHobbiePopup(kh)"
                  class="hover:text-gray-900 cursor-pointer"
                >
                  Choisir une image
                </p>
                <p
                  @click.stop="displayChooseIconHobbiePopup(kh)"
                  class="hover:text-gray-900 cursor-pointer"
                >
                  Choisir une icône
                </p>
                <p
                  v-if="!hobbie.fromNeopass"
                  @click.stop="removeHobbie(kh)"
                  class="hover:text-gray-900 cursor-pointer"
                >
                  Supprimer
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(hobbie, kh) in newHobbies"
          :key="'newhobbie' + kh"
          class="col-span-full grid grid-cols-12 gap-x-4 py-5 odd:bg-gray-200 items-center odd:bg-opacity-50"
        >
          <div class="col-span-2 flex items-center justify-center">
            <CVNewValue
              :old="hobbie"
              @addNew="
                (newValue) => {
                  importFromNeopass(hobbie);
                }
              "
              :right="false"
              :is-new="true"
            />
          </div>
          <div class="col-span-7 flex space-x-1 items-center justify-between">
            <div class="flex space-x-4 items-center">
              <icon :name="hobbie.icon" />
              <p class="text-base font-normal">
                {{ hobbie.value }}
              </p>
            </div>
            <img
              v-if="hobbie.image && hobbie.image != ''"
              :src="hobbie.image"
              class="h-8 w-8 object-cover rounded-md"
            />
          </div>

          <div class="col-span-3 flex space-x-3 px-6" />
        </div>
      </div>

      <add-button
        class="mt-10 mx-10"
        libelle="Ajouter d'autres centres d'intérêt"
        @add="changeStateNewHobbiePopup(true)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';

import AddButton from './../../../components/Inputs/AddButton.vue';
import Icon from './../../../components/Icon.vue';
import Tag from './../../../components/Tag.vue';
import NewHobbiePopup from './../popup/NewHobbiePopup.vue';
import ChangePicturePopup from '../popup/ChangePicturePopup.vue';
import ChangeIconPopup from '../popup/ChangeIconPopup.vue';
import RadioButton from './../../../components/Inputs/RadioButton.vue';

import ActionButton from './../../../components/ActionButton.vue';
import Illustration from './../../../components/Illustration.vue';
import CVNewValue from './CVNewValue';

import Constants from './../../../constants';
import ClickOutside from 'vue-click-outside';

export default {
  components: {
    AddButton,
    Icon,
    Tag,
    NewHobbiePopup,
    draggable,
    ActionButton,
    Illustration,
    CVNewValue,
    RadioButton,
    ChangePicturePopup,
    ChangeIconPopup,
  },

  data() {
    return {
      isNewHobbiePopupDisplayed: false,
      isChoosePicPopupDisplayed: false,
      isChooseIconPopupDisplayed: false,
      metierToDisplay: '',
      constants: Constants,
      menuMoreDisplayed: -1,
      indexHobbieToEdit: -1,
      isErrorMaxLengthDisplayed: false,
      isErrorMinLengthDisplayed: false,
    };
  },

  methods: {
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),

    displayMetier(metier) {
      if (this.metierToDisplay === metier) {
        this.metierToDisplay = '';
        return;
      }

      this.metierToDisplay = metier;
    },

    changeStateNewHobbiePopup(state) {
      if (!state) this.indexHobbieToEdit = -1;
      this.isNewHobbiePopupDisplayed = state;
    },

    changeStateChoosePicPopup(state) {
      if (!state) this.indexHobbieToEdit = -1;
      this.isChoosePicPopupDisplayed = state;
    },

    changeStateChooseIconPopup(state) {
      if (!state) this.indexHobbieToEdit = -1;
      this.isChooseIconPopupDisplayed = state;
    },

    addNewHobbie(name) {
      let list = name.split(',').map((w) => w.trim());

      list.forEach((comp) => {
        this.form.data.hobbies.push({
          fromNeopass: false,
          isDisplayed:
            this.hasLimit && this.nbDisplayedHobbies >= 1 ? false : true,
          value: comp,
          image: '',
          icon: '',
        });
      });

      this.saveDatas();
      this.$forceUpdate();
    },

    modifyHobbie(name) {
      this.hobbies[this.indexHobbieToEdit].value = name;
    },

    changePic(url) {
      this.form.data.hobbies[this.indexHobbieToEdit].image = url;

      this.saveDatas();
      this.$forceUpdate();
    },

    changeIcon(icon) {
      this.form.data.hobbies[this.indexHobbieToEdit].icon = icon;

      this.saveDatas();
      this.$forceUpdate();
    },

    displayHobbie(index) {
      if (this.hasLimit) {
        if (
          !this.form.data.hobbies[index].isDisplayed &&
          this.nbDisplayedHobbies >= 3
        ) {
          this.isErrorMaxLengthDisplayed = true;
          return;
        }
        if (
          this.form.data.hobbies[index].isDisplayed &&
          this.nbDisplayedHobbies === 3
        ) {
          this.isErrorMaxLengthDisplayed = false;
        }
        if (
          this.form.data.hobbies[index].isDisplayed &&
          this.nbDisplayedHobbies <= 3
        ) {
          this.isErrorMinLengthDisplayed = true;
        }
        if (
          !this.form.data.hobbies[index].isDisplayed &&
          this.nbDisplayedHobbies >= 2
        ) {
          this.isErrorMinLengthDisplayed = false;
        }
      }

      this.form.data.hobbies[index].isDisplayed =
        !this.form.data.hobbies[index].isDisplayed;
      this.$forceUpdate();
    },

    removeHobbie(index) {
      this.form.data.hobbies.splice(index, 1);
      this.$forceUpdate();
    },

    importFromNeopass(hobbie) {
      this.form.data.hobbies.push(hobbie);

      //delete hobbie;

      this.saveDatas();
      this.$forceUpdate();
    },

    displayMenuMore(num) {
      this.menuMoreDisplayed = num;
    },

    hideMenuMore() {
      this.menuMoreDisplayed = -1;
    },

    displayModifyHobbiePopup(num) {
      this.indexHobbieToEdit = num;
      this.changeStateNewHobbiePopup(true);
      this.hideMenuMore();
    },

    displayChoosePicHobbiePopup(num) {
      this.indexHobbieToEdit = num;
      this.changeStateChoosePicPopup(true);
      this.hideMenuMore();
    },

    displayChooseIconHobbiePopup(num) {
      this.indexHobbieToEdit = num;
      this.changeStateChooseIconPopup(true);
      this.hideMenuMore();
    },

    removeFormation(num) {
      this.form.data.hobbies.splice(num, 1);
      this.hideMenuMore();
    },

    removePic(index) {
      this.form.data.hobbies[index].image = '';
    },

    removeIcon(index) {
      this.form.data.hobbies[index].icon = '';
    },
  },

  computed: {
    ...mapGetters({
      form: 'curriculumVitae/form',
      newer: 'curriculumVitae/newForm',
    }),

    hobbies() {
      return this.form.data.hobbies;
    },

    newHobbies() {
      return this.newer.data.hobbies ? this.newer.data.hobbies : [];
    },

    dragOptions() {
      return {
        animation: 500,
      };
    },

    nbDisplayedHobbies() {
      this.backdoor; //for reactivity

      return [...new Set(Object.values(this.hobbies).flat())].filter(
        (h) => h.isDisplayed
      ).length;
    },

    hasLimit() {
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    },

    isWithPictures() {
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    },
  },

  watch: {
    form: {
      handler() {
        this.saveDatas();
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
